var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { ShopifyConstants } from './ShopifyConstants';
const queryString = require('query-string');
class Ajax {
    getProduct(productHandle) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield axios.get('/products/' + productHandle + '.js')).data;
        });
    }
    getCollagenPeptides() {
        return this.getProduct('collagen-peptides');
    }
    addItemsToCart(items) {
        return axios.post('/cart/add.js', { items });
    }
    addToCart(variantId, quantity = 1) {
        return this.addItemsToCart([
            {
                id: variantId,
                quantity,
            },
        ]);
    }
    addToCartAndRedirect(variantId, quantity = 1) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addToCart(variantId, quantity);
            window.location.href = '/cart';
        });
    }
    addSubscriptionToCart(variantId, quantity = 1, intervalInWeeks = 4) {
        return this.addItemsToCart([
            {
                id: variantId,
                quantity,
                properties: {
                    shipping_interval_frequency: intervalInWeeks,
                    shipping_interval_unit_type: 'Weeks',
                },
            },
        ]);
    }
    addSubscriptionToCartAndRedirect(variantId, quantity = 1, intervalInWeeks = 4) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.addSubscriptionToCart(variantId, quantity, intervalInWeeks);
            window.location.href = '/cart';
        });
    }
}
export const MAIN_BACKEND_URL = process.env.MAIN_BACKEND_URL ||
    'https://vitalproteins-main-backend.herokuapp.com/api';
const queryVariables = queryString.parse(location.search);
class Backend {
    constructor() {
        let mainBackendHeaders = {};
        if (queryVariables.recharge_hash) {
            mainBackendHeaders = {
                'x-recharge-user-hash': queryVariables.recharge_hash,
            };
        }
        else if (ShopifyConstants === null || ShopifyConstants === void 0 ? void 0 : ShopifyConstants.customer) {
            mainBackendHeaders = {
                'x-vital-proteins-user-hash': ShopifyConstants.customer.hash,
                'x-vital-proteins-user-email': ShopifyConstants.customer.email,
            };
        }
        this.mainBackendAxios = axios.create({
            baseURL: MAIN_BACKEND_URL,
            headers: mainBackendHeaders,
        });
        const customMainBackendURL = MAIN_BACKEND_URL.replace('api', '');
        this.fullMainBackendAxios = axios.create({
            baseURL: customMainBackendURL,
            headers: mainBackendHeaders,
        });
        const storeFrontHeaders = {
            'X-Shopify-Storefront-Access-Token': process.env.SHOPIFY_API_GRAPHQL_TOKEN ||
                '0ef09777e9d54d7e83b86a99cf59142e',
        };
        const adminApiHeaders = {
            'X-Shopify-Access-Token': '0ef09777e9d54d7e83b86a99cf59142e',
        };
        this.searchanise = axios.create({
            baseURL: 'https://www.searchanise.com/getwidgets?api_key=0j5Y8H4I9K&startIndex=0&items=true&pages=true&facets=false&categories=true&suggestions=true&vendors=false&tags=false&pageStartIndex=0&pagesMaxResults=0&categoryStartIndex=0&categoriesMaxResults=0&suggestionsMaxResults=4&vendorsMaxResults=3&tagsMaxResults=3&output=json',
        });
        this.storeFrontAxios = axios.create({
            baseURL: process.env.SHOPIFY_API_GRAPHQL_BASE_URL ||
                'https://vital-proteins.myshopify.com/api/2021-01/graphql.json',
            headers: storeFrontHeaders,
        });
        this.adminApiAxios = axios.create({
            baseURL: 'https://vital-proteins.myshopify.com/admin/api/2021-01/graphql.json',
            headers: adminApiHeaders,
        });
    }
    redirectIfNotLoggedIn() {
        if (!this.isLoggedIn()) {
            this.redirectToLogin();
        }
    }
    redirectToLogin() {
        location.replace('/account/login?return_url=' + encodeURI(location.href));
    }
    isLoggedIn() {
        return ShopifyConstants.customer || queryVariables.recharge_hash;
    }
    getCollection(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.storeFrontAxios.post('', {
                query: `
      {
        collections(first: 1, query: "id:${id}") {
          edges{
            node{
              title
              products(first: 20){
                edges{
                  node{
                    id
                    title
                    onlineStoreUrl
                    tags
                    metafield(namespace: "subscriptions", key: "discount_percentage"){
                      value
                    }
                    images(first: 1){
                      edges{
                        node{
                          originalSrc
                          card: transformedSrc(maxHeight: 192)
                          packageOption: transformedSrc(maxWidth: 100, maxHeight: 100)
                        }
                      }
                    }
                    variants(first: 20){
                      edges{
                        node{
                          id
                          title
                          currentlyNotInStock
                          quantityAvailable
                          metafield(namespace: "subscriptions", key: "discount_variant_price"){
                            value
                          }
                          priceV2{
                            amount
                          }
                          image{
                            originalSrc
                            card: transformedSrc(maxHeight: 192)
                            packageOption: transformedSrc(maxWidth: 100, maxHeight: 100)
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          
        }
      }`,
            })).data;
        });
    }
    getProduct(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.storeFrontAxios.post('', {
                query: `
      {
        products(first: 1, query: "id:${id}"){
          edges{
            node{
              id
              title
              onlineStoreUrl
              tags
              metafield(namespace: "subscriptions", key: "discount_percentage"){
                value
              }
             shippingIntervals: metafield(namespace: "subscriptions", key:"shipping_interval_frequency"){
                value
              }
             shippingIntervalUnit: metafield(namespace: "subscriptions", key:"shipping_interval_unit_type"){
                value
              }
              images(first: 1){
                edges{
                  node{
                    originalSrc
                    card: transformedSrc(maxHeight: 192)
                    packageOption: transformedSrc(maxWidth: 100, maxHeight: 100)
                  }
                }
              }
              variants(first: 20){
                edges{
                  node{
                    id
                    title
                    currentlyNotInStock
                    quantityAvailable
                    metafield(namespace: "subscriptions", key: "discount_variant_price"){
                      value
                    }
                    discountVariantId: metafield(namespace: "subscriptions", key: "discount_variant_id"){
                      value
                    }
                    priceV2{
                      amount
                    }
                    image{
                      originalSrc
                      card: transformedSrc(maxHeight: 192)
                      packageOption: transformedSrc(maxWidth: 100, maxHeight: 100)
                    }
                  }
                }
              }
            }
          }
        }
      }`,
            })).data;
        });
    }
    saveCustomerQuiz(email, quiz) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mainBackendAxios.post('customerquiz/' + email, quiz);
        });
    }
    getReferralLink(email) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get('referrallink/' + email)).data;
        });
    }
    sendReferralEmails(email, emails) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.mainBackendAxios.post('sendreferralemails', { email, emails });
        });
    }
    getCustomerSubscriptions() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get('customer/subscriptions')).data;
        });
    }
    getCustomerSubscriptionOnetimes() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get('customer/subscriptions/onetimes'))
                .data;
        });
    }
    getCustomerSubscriptionsAddresses() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get('customer/subscriptions/addresses'))
                .data;
        });
    }
    createSubscription(subscription) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.post('customer/subscriptions', subscription)).data;
        });
    }
    createOnetime(onetime) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.post('customer/subscriptions/onetimes', onetime)).data;
        });
    }
    deleteOnetime(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.delete('customer/subscriptions/onetimes/' + id)).data;
        });
    }
    updateSubscription(subscription) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.put('customer/subscriptions', subscription)).data;
        });
    }
    activateSubscription(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.post('customer/subscriptions/' + id + '/activate')).data;
        });
    }
    cancelSubscription(id, email, hash) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get(`customer/subscriptions/${id}/cancel2?email=${email}&hash=${hash}`)).data;
        });
    }
    sendUpdatePaymentEmail(address_id) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.post('customer/send-payment-update-email', {
                address_id,
            })).data;
        });
    }
    getCustomerNoAwait() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('customer');
        });
    }
    getFreeGift() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.get('customer/subscriptions/freegift'))
                .data;
        });
    }
    addFreeGift() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.mainBackendAxios.post('customer/subscriptions/freegift'))
                .data;
        });
    }
    search(query, maxResults = 3) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.searchanise.get(`&q=${query}&maxResults=${maxResults}`);
        });
    }
    getOrderHistory() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('customer/orders');
        });
    }
    getProductImage(productID) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get(`product/${productID}/image/`);
        });
    }
    getCustomerDefaultAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('customer/defaultAddress');
        });
    }
    saveCustomerDefaultAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.patch('customer/defaultAddress', address);
        });
    }
    getCustomerAddresses() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('customer/addresses');
        });
    }
    saveCustomerAddress(address) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.patch('customer/address', address);
        });
    }
    deleteCustomerAddress(addressId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.delete(`customer/address/${addressId}`);
        });
    }
    markCustomerAddressAsDefault(address) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.patch('customer/address/markAsDefault', address);
        });
    }
    getAllCountries() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('countries');
        });
    }
    fetchPaymentMethod() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.get('customer/paymentInformation');
        });
    }
    savePaymentInformation(paymentMethod) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.patch('customer/paymentInformation', paymentMethod);
        });
    }
    saveContactFromQuiz(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.post('klaviyo/quiz-contact/add', data);
        });
    }
    validateAndFormatPersonaMessage(data, signature) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.mainBackendAxios.post('../quiz/validateAndFormat', data, {
                headers: {
                    'Content-Type': 'text/plain',
                    'X-Vital-Authorization': signature,
                },
            });
        });
    }
}
export const API = {
    Ajax: new Ajax(),
    Backend: new Backend(),
};
